import {Layout, Text} from '@ui-kitten/components';
import React from 'react';
import {TouchableOpacity, StyleSheet} from 'react-native';
import {px} from '../../../../utils';
import themeColors from '../../../../assets/json/custom-theme.json';
import moment from 'moment';

const RowCard = ({data, onPress}) => {
  const {title, date_created} = data;

  return (
    <TouchableOpacity onPress={onPress}>
      <Layout style={styles.container}>
        <Layout style={styles.leftCol}>
          {/*   {!isSeen && <View style={styles.newDot} />} */}
        </Layout>
        <Layout style={styles.rightCol}>
          <Text numberOfLines={2}>{title}</Text>
          <Text appearance="hint" style={styles.date}>
            {moment(date_created).format('DD MMM, YYYY h:mm A')}
          </Text>
        </Layout>
      </Layout>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: px(5),
    paddingVertical: px(17),
    flexDirection: 'row',
    borderBottomColor: '#FF5722',
    borderBottomWidth: 0.5,
  },
  rightCol: {
    paddingLeft: px(7),
    flex: 0.8,
  },
  leftCol: {
    paddingTop: px(4),
    width: px(17),
  },
  newDot: {
    backgroundColor: themeColors['color-primary-500'],
    borderRadius: 50,
    width: px(17),
    height: px(17),
  },
  date: {
    fontSize: 12,
    marginTop: px(7),
  },
});

export default RowCard;
